/* eslint-disable no-undef */
import {
  GOLD_TRANSACTION_ALL,
  GOLD_TRANSACTION_GET,
  GOLD_TRANSACTION_DEL,
  GOLD_TRANSACTION_PUT,
  GOLD_TRANSACTION_POST,
  GOLD_TRANSACTION_LOADING,
  GOLD_TRANSACTION_ERROR,
  GOLD_TRANSACTION_DECREASE,
  GOLD_TRANSACTION_RESET,
  GOLD_TRANSACTION_GET_HISTORY,
  GOLD_TRANSACTION_SUMMARY_MONTHLY,
} from '../types';

import api from '../../../utils/functions/api';

export const goldTransactionCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: GOLD_TRANSACTION_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/gold`,
      payload,
    );
    dispatch({ type: GOLD_TRANSACTION_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: GOLD_TRANSACTION_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};
export const goldTransactionDecrease = (payload) => async (dispatch) => {
  try {
    dispatch({ type: GOLD_TRANSACTION_LOADING });

    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/gold`,
      payload,
    );
    dispatch({ type: GOLD_TRANSACTION_DECREASE, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: GOLD_TRANSACTION_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};
export const getGoldTransactionSummary =
  (
    { year = '', month = '' }, // เพิ่ม default value ให้ parameter คล้ายกับตัวอย่าง
  ) =>
  async (dispatch) => {
    try {
      // 1. Dispatch LOADING action (ยังคงไว้เพราะเป็น action สำหรับโหลดข้อมูล summary)
      dispatch({ type: GOLD_TRANSACTION_LOADING });

      // 2. สร้าง URL ด้วย template string และเรียก API
      const { data, status } = await api.get(
        `${process.env.REACT_APP_API_URL}/gold/summary/monthly?year=${year}&month=${month}`,
      );

      // 3. ตรวจสอบ status ก่อน dispatch SUCCESS
      if (status === 200) {
        // 4. Dispatch SUCCESS action
        // **หมายเหตุ:** ยังคงใช้ payload: data.data ตามคอมเมนต์ในโค้ดเดิมของคุณ
        // เนื่องจาก response จากแต่ละ API endpoint อาจมีโครงสร้างต่างกัน
        dispatch({
          type: GOLD_TRANSACTION_SUMMARY_MONTHLY,
          payload: data,
        });
      }

      return data;
    } catch (error) {
      // 5. หากเกิดข้อผิดพลาด Dispatch ERROR action
      console.error(error);
      dispatch({ type: GOLD_TRANSACTION_ERROR });
      throw new Error(error); // ปรับการ throw error ให้เหมือนตัวอย่าง
    }
  };

export const goldTransactionAll =
  ({
    name = '',
    size = '',
    page = 1,
    place = '',
    statusPlace = '',
    startDate = '',
    endDate = '',
    date = '',
    month = '',
    year = '',
    all = false,
  }) =>
  async (dispatch) => {
    try {
      dispatch({ type: GOLD_TRANSACTION_RESET });
      const { data, status } = await api.get(
        `${process.env.REACT_APP_API_URL}/gold?name=${name}&size=${size}&page=${page}&place=${place}&statusPlace=${statusPlace}&all=${all}&startDate${startDate}&endDate${endDate}&date=${date}&month=${month}&year=${year}`,
      );
      if (status === 200) {
        dispatch({ type: GOLD_TRANSACTION_ALL, payload: data });
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: GOLD_TRANSACTION_ERROR });
      throw new Error(error);
    }
  };

export const goldTransactionAllcash =
  ({
    name = '',
    size = '',
    page = 1,
    cash = '',
    startDate = '',
    endDate = '',
    date = '',
    month = '',
    year = '',
  }) =>
  async (dispatch) => {
    try {
      dispatch({ type: GOLD_TRANSACTION_RESET });
      const { data, status } = await api.get(
        `${process.env.REACT_APP_API_URL}/gold?name=${name}&size=${size}&page=${page}&cash=${cash}&startDate${startDate}&endDate${endDate}&date=${date}&month=${month}&year=${year}`,
      );
      if (status === 200) {
        dispatch({ type: GOLD_TRANSACTION_ALL, payload: data });
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: GOLD_TRANSACTION_ERROR });
      throw new Error(error);
    }
  };

export const goldTransactionAlltransfer =
  ({
    name = '',
    size = '',
    page = 1,
    transfer = '',
    startDate = '',
    endDate = '',
    date = '',
    month = '',
    year = '',
  }) =>
  async (dispatch) => {
    try {
      dispatch({ type: GOLD_TRANSACTION_RESET });
      const { data, status } = await api.get(
        `${process.env.REACT_APP_API_URL}/gold?name=${name}&size=${size}&page=${page}&transfer=${transfer}&startDate${startDate}&endDate${endDate}&date=${date}&month=${month}&year=${year}`,
      );
      if (status === 200) {
        dispatch({ type: GOLD_TRANSACTION_ALL, payload: data });
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: GOLD_TRANSACTION_ERROR });
      throw new Error(error);
    }
  };

export const goldTransactionGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/gold/${id}`,
    );
    if (status === 200) {
      dispatch({ type: GOLD_TRANSACTION_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: GOLD_TRANSACTION_ERROR });
    throw new Error(error);
  }
};

export const goldTransactionGetHistory = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/gold/history/${id}`,
    );
    if (status === 200) {
      dispatch({ type: GOLD_TRANSACTION_GET_HISTORY, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: GOLD_TRANSACTION_ERROR });
    throw new Error(error);
  }
};

export const goldTransactionPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: GOLD_TRANSACTION_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/gold/${id}`,
      payload,
    );
    dispatch({ type: GOLD_TRANSACTION_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: GOLD_TRANSACTION_ERROR });
    throw new Error(error);
  }
};
export const goldTransactionDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: GOLD_TRANSACTION_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/gold/${id}`,
    );
    dispatch({ type: GOLD_TRANSACTION_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: GOLD_TRANSACTION_ERROR });
    console.error(error);
    throw new Error(error);
  }
};

export const goldTransactionReset = () => async (dispatch) => {
  try {
    dispatch({ type: GOLD_TRANSACTION_RESET });
  } catch (error) {
    console.error(error);
    dispatch({ type: GOLD_TRANSACTION_ERROR });
    throw new Error(error);
  }
};
